import { render, staticRenderFns } from "./supply-sale.vue?vue&type=template&id=3f71b0ed&scoped=true"
import script from "./supply-sale.vue?vue&type=script&lang=ts"
export * from "./supply-sale.vue?vue&type=script&lang=ts"
import style0 from "./supply-sale.vue?vue&type=style&index=0&id=3f71b0ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f71b0ed",
  null
  
)

export default component.exports